import {
    ApiBankCard,
    ApiPaymentMethod,
    ApiSbpToken,
    BankCard,
    BankCardSystem,
    PaymentMethodType,
    SbpToken,
} from '../../types';
import { formatCardNumber, isMethodIdCard, isMethodIdSbp } from '../../utils/common';

const normalizeCards = (cards: ApiBankCard[]): BankCard[] => {
    return (
        cards
            .sort((card1, card2) => card2.last_paid_ts - card1.last_paid_ts || 0)
            // eslint-disable-next-line
            .map((rawCard) => {
                const system = rawCard.system.toLowerCase();
                const partnerInfo = rawCard.partner_info;

                const card = {
                    id: rawCard.id,
                    type: PaymentMethodType.card,
                    number: formatCardNumber(rawCard.number),
                    system: BankCardSystem.unknown,
                } as BankCard;

                switch (system) {
                    case 'visa':
                        card.system = BankCardSystem.visa;
                        break;
                    case 'mastercard':
                        card.system = BankCardSystem.mastercard;
                        break;
                    case 'maestro':
                        card.system = BankCardSystem.maestro;
                        break;
                    case 'mir':
                        card.system = BankCardSystem.mir;
                        break;
                }

                if (partnerInfo) {
                    let { yabank_card_labels: yabankCardLabels } = partnerInfo;

                    const { is_yabank_card: isYabankCard, is_yabank_card_owner: isYabankCardOwner } = partnerInfo;

                    if (isYabankCard && isYabankCardOwner && (!yabankCardLabels || yabankCardLabels.length === 0)) {
                        yabankCardLabels = ['YANDEX_BANK_PLUS_CARD'];
                    }

                    card.partnerInfo = {
                        isYabankCard,
                        isYabankCardOwner,
                        yabankCardLabels,
                    };
                }

                if (rawCard.card_bank) {
                    card.issuer = rawCard.card_bank;
                }

                return card;
            })
    );
};

export const normalizeMethods = (methods: ApiPaymentMethod[]): Array<BankCard | SbpToken> => {
    const cards = methods.filter((item) => isMethodIdCard(item.id)) as ApiBankCard[];
    const sbpTokens = methods.filter((item) => isMethodIdSbp(item.id)) as ApiSbpToken[];

    return ([] as Array<BankCard | ApiSbpToken>).concat(normalizeCards(cards), sbpTokens);
};
